/**
 * «Темы разговоров» со своим запросом раздела — экран «Сайта и контента» без
 * вопросов клиентов (срез `questions`). Сам блок и его правила — в
 * `VoiceThemesBlock`; вкладки слоями рисуют его с запросом вкладки (#2060, #2072).
 */
import type { VoiceThemeCuts } from '@aica/api-types/schemas';
import { useVoiceThemesAvailable } from './themes/useVoiceThemes';
import { useVoiceThemeAnalytics } from './useVoiceOfCustomer';
import { VoiceThemesBlock, type VoiceThemesBlockProps } from './VoiceThemesBlock';

export interface VoiceThemesPanelProps extends Omit<VoiceThemesBlockProps, 'query'> {
  /** The tab's cut: Sales reads `outcomes`, Site and content reads `questions`. */
  cut: VoiceThemeCuts;
}

export function VoiceThemesPanel({ cut, ...block }: VoiceThemesPanelProps) {
  const available = useVoiceThemesAvailable();
  const query = useVoiceThemeAnalytics(
    block.search,
    block.onSearchChange,
    cut,
    available
  );
  return <VoiceThemesBlock query={query} {...block} />;
}
